import * as React from "react"
import { format, parse, isValid } from "date-fns"
import { Calendar as CalendarIcon } from "lucide-react"
import { cn } from "../../lib/utils"
import { Button } from "../../component/ui/button"
import { Calendar } from "../../component/ui/calender"
import { Popover, PopoverContent, PopoverTrigger } from "../../component/ui/popover"

export function DatePickerForSchemes({ className, value, onChange, disabled }) {
  const [date, setDate] = React.useState(() => {
    if (value) {
      let parsedDate = null;

      // // If the value is a string, try to parse it into a date
      // if (typeof value === 'string') {
      //   parsedDate = parse(value, "dd.MM.yyyy", new Date());
      // }

      if (value) {
        const parsedDate = new Date(value); // Parse the date using the Date constructor
        return isValid(parsedDate) ? parsedDate : null;
      }

      // If parsing fails or the parsed date is invalid, try converting it directly
      if (parsedDate && isValid(parsedDate)) {
        return parsedDate;
      } else if (value instanceof Date && isValid(value)) {
        return value; // If it's already a valid Date object, use it
      }
    }

    return null; // Return null if no valid date is found
  });

  const handleDateChange = (selectedDate) => {
    setDate(selectedDate);
    onChange(selectedDate);  // Trigger the onChange passed from the parent
  };

  const currentDate = new Date();
  const year = currentDate.getFullYear();

  return (
    <div>
      <Popover>
        <PopoverTrigger asChild>
          <Button
            disabled={disabled}
            variant={"outline"}
            className={cn(
              "w-[280px] justify-start text-left font-normal border-[#3a5dd1] h-10",
              !date && "text-muted-foreground",
              className
            )}
          >
            <CalendarIcon className="mr-2 h-4 w-4" />
            {date ? format(date, "PPP") : <span>Pick a date</span>}
          </Button>
        </PopoverTrigger>
        <PopoverContent className="w-auto p-0">
          <Calendar
            captionLayout="dropdown-buttons"
            fromYear={1900}
            toYear={year}
            mode="single"
            selected={date}
            onSelect={handleDateChange}  // Use the handler for selecting the date
            disabled={(date) => date > new Date()}
            initialFocus
            className="bg-white border-[#3a5dd1] border rounded-lg"
          />
        </PopoverContent>
      </Popover>
    </div>
  );
}
